<template>
  <ChartCard>
    <ChartHeader label>
      <v-skeleton-loader
        type="text"
        min-width="100%"
        height="20px"
        class="header-text"
      />
    </ChartHeader>
    <div class="w-100 pa-4 d-flex align-center justify-center ga-4 chart-container">
      <DpplSkeletonLoader class="w-100 completion-dppl-loader">
        <div class="completion-loader-chart h-100">
          <div class="h-100" />
          <div class="h-100" />
          <div class="h-100" />
        </div>
      </DpplSkeletonLoader>
      <div class="d-flex flex-column align-start justify-start">
        <div class="d-flex align-center justify-start mb-2">
          <DpplSkeletonLoader class="mr-2">
            <div class="colored-dot-loader" />
          </DpplSkeletonLoader>
          <v-skeleton-loader class="mr-2" type="text" height="12px" width="52px" />
          <v-skeleton-loader type="text" height="12px" width="52px" />
        </div>
        <div class="d-flex align-center justify-start mb-2">
          <DpplSkeletonLoader class="mr-2">
            <div class="colored-dot-loader" />
          </DpplSkeletonLoader>
          <v-skeleton-loader class="mr-2" type="text" height="12px" width="52px" />
          <v-skeleton-loader type="text" height="12px" width="52px" />
        </div>
        <div class="d-flex align-center justify-start">
          <DpplSkeletonLoader class="mr-2">
            <div class="colored-dot-loader" />
          </DpplSkeletonLoader>
          <v-skeleton-loader class="mr-2" type="text" height="12px" width="52px" />
          <v-skeleton-loader type="text" height="12px" width="52px" />
        </div>
      </div>
    </div>
  </ChartCard>
</template>

<script setup>
import ChartCard from '@/components/insights/Chart/ChartCard.vue';
import ChartHeader from '@/components/insights/Chart/ChartHeader.vue';
import DpplSkeletonLoader from '@/components/datapeople/DpplSkeletonLoader.vue';
</script>

<style lang="less" scoped>
:deep(.v-skeleton-loader__text) {
  margin: 0 !important;
}

.header-text:deep(.v-skeleton-loader__bone) {
  height: 16px;
}

.chart-container {
  padding: 16px;
  height: 120px;
}

.completion-dppl-loader {
  height: 55px;
}

.completion-loader-chart {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 27px 24px;
  height: 55px;

  div:last-child {
    background: fade(@grey-900, 20%);
    border-radius: 0 4px 4px 0;
  }

  div:nth-child(2) {
    background: fade(@grey-900, 15%);
  }

  div:first-child {
    background: fade(@grey-900, 10%);
    border-radius: 4px 0 0 4px;
  }
}

.colored-dot-loader {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: fade(@grey-900, 15%);
}
</style>
